/**
 * Nice resource for cursor change: https://stackoverflow.com/a/54999431
 * W3 cursor options: https://www.w3.org/TR/CSS21/ui.html#propdef-cursor
 * All cursors at glance: https://stackoverflow.com/a/5697095
 */
export default {

    data() {
        return {
            draggableInProgress: false,
            draggableCursor: "move"
        }
    },

    computed: {

        draggableCursorMoveWhenDragged() {
            return {cursor: this.draggableInProgress ? this.draggableCursor + ' !important' : 'default'}
        },
        /** Not in use but what this does is, it would prevent the selector for being dragged. i.e. stop drag for the below selector
         draggableIgnoreElementsWhenDragging() {
            return '.v-expansion-panel-header__icon'
        }*/

    },

    methods: {

        draggableDragStart(event) {
            let self = this;
            self.draggableInProgress = true;
        },
        draggableDragEnd(event) {

            let self = this;
            self.draggableInProgress = false;

        },
        draggableDragEndForUserGroup(event) {

            let self = this;
            self.draggableInProgress = false;

            if (event.oldIndex === self.categoryPanel) {
                self.categoryPanel = event.newIndex
            }
        }
    }

}
